/**
 * De-duplicated insurers from motor uidata configuration.
 * @param {object} apiResponse - Axios-style response whose `data` holds category buckets with `insuranceAndProducts` arrays.
 * @returns {{ insuranceCompanyCode: string, insuranceCompanyName: string }[]}
 */
export function extractInsuranceCompanies(apiResponse) {
  const companyMap = new Map();
  const body = apiResponse?.data;
  const categoryRoot =
    body &&
    typeof body === 'object' &&
    body.data != null &&
    typeof body.data === 'object' &&
    !Array.isArray(body.data)
      ? body.data
      : body;

  Object.values(categoryRoot || {}).forEach((category) => {
    const insuranceList = category.insuranceAndProducts || [];

    insuranceList.forEach((item) => {
      const code = item.insuranceCompanyCode;
      const name = item.insuranceCompanyName;

      if (code && name && !companyMap.has(code)) {
        companyMap.set(code, {
          insuranceCompanyCode: code,
          insuranceCompanyName: name,
        });
      }
    });
  });

  return Array.from(companyMap.values()).sort((a, b) =>
    a.insuranceCompanyName.localeCompare(b.insuranceCompanyName)
  );
}
